import { render, staticRenderFns } from "./CreateCampaignSetupsType.vue?vue&type=template&id=669a66e8&scoped=true"
import script from "./CreateCampaignSetupsType.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSetupsType.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignSetupsType.vue?vue&type=style&index=0&id=669a66e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669a66e8",
  null
  
)

export default component.exports